import { useEffect, useState } from 'react';
import AppWrappedMultiselect from '../../AppWrappedMultiselect';
import { fetchServiceAreaData } from '../../79/_api';

/**
 * Service Area input component for Epic/EpicCare stylized to work with Custom App Request Form
 * @param {Object} props properties
 * @returns Custom input
 */
const ServiceAreaField = props => {
	const [loadingStatus, setLoadingStatus] = useState(true);
	const [optionsList, setOptionsList] = useState([]);
	useEffect(() => {
		fetchServiceAreaData()
			.then(response => {
				setOptionsList(response);
				setLoadingStatus(false);
			})
			.catch(e =>
				props.formik.setStatus({
					error: {
						source: props.name,
						cause: 'API Failure',
						details: e,
						message:
							'Unable to retrieve service areas for the input component.  Please try again.',
					},
				})
			);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<AppWrappedMultiselect
			label='Service Areas'
			options={optionsList}
			isLoading={loadingStatus}
			helperText='The service area is the first two digits of your Epic Department ID number.'
			{...props}
		/>
	);
};

export default ServiceAreaField;
